export default "__VITE_ASSET__fee5cc68__"